interface Props {
  letter: string;
  color: string;
  size?: number;
}

const AgentAvatar = ({ letter, color, size = 44 }: Props) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: 700,
        fontSize: size <= 24 ? 10 : size <= 44 ? 18 : 28,
        fontFamily: '"Eudoxus Sans", sans-serif',
        flexShrink: 0
      }}
    >
      {letter}
    </div>
  );
};

export default AgentAvatar;
